import { Spacer as PatternSpacer } from '@porsche-code/kado-styled-system/jsx';
import type { SpacingToken } from '@porsche-code/kado-styled-system/types';

export const Spacer = ({
  pt,
  pb,
  mt,
  mb,
}: {
  pt?: SpacingToken;
  pb?: SpacingToken;
  mt?: SpacingToken;
  mb?: SpacingToken;
}) => <PatternSpacer pt={pt} pb={pb} mt={mt} mb={mb} />;
